import DataExtension from "./components/DataExtension.vue";
import CampaignFolder from "./components/CampaignFolder";

import dataExtensionServiceFactory from "./services/data-extension-service.js";
import folderServiceFactory from "./services/folder-service.js";

export default {
    name: 'CreationStation',
    components: {
        DataExtension,
        CampaignFolder
    },
    data: function() {
        var folderData = [
            {
                id: "myEmails",
                label: "Create Email Folder",
                rootFolderName: "My Emails"
            },
            {
                id: "portfolio",
                label: "Create Portfolio Folder",
                rootFolderName: "Portfolio"
            },
            {
                id: "userInitiated",
                label: "Create User-Initiated Emails Folder",
                rootFolderName: "User-Initiated"
            },
            {
                id: "dataExtensions",
                label: "Create Data Extension Folder",
                rootFolderName: "Data Extensions"
            }
        ];

        var data = {
            campaignName: "",
            createFolders: {},
            dataExtensions: [],
            apiResponseRaw: null,
            sfmcErrorStatusMessage: null,
            formProperties: {
                status: "editing",
                dataExtensionBeingEdited: null
            }
        };

        folderData.forEach(folder => {
            data.createFolders[folder.id] = this.$folderService.folderAdd(
                folder.id,
                folder.label,
                folder.rootFolderName
            );
        })

        return data;
    },
    beforeCreate: function() {
        this.$dataExtensionService = dataExtensionServiceFactory(this);
        this.$folderService = folderServiceFactory(this);
    },
    computed: {
        createFolderPaths: function() {
            var paths = {};
            Object.keys(this.createFolders).forEach((k) => {
                var folder = this.createFolders[k];
                paths[k] = (
                    folder.path ?
                    (
                        folder.path+
                        (
                            this.campaignName ?
                            `/${this.campaignName}` :
                            ""
                        )
                    ) :
                    ""
                );
            });
            return paths;
        }
    },
    methods: {
        submit: function() {
            if (this.formProperties.dataExtensionBeingEdited) {
                alert("Please finish editing data extensions before submitting.");
                return;
            }

            if (!this.campaignName) {
                alert("Please enter a campaign name.");
                return;
            }

            this.$folderService.processFolders(this.campaignName, this.createFolders)
            .then(
                () => this.$dataExtensionService.processDataExtensions(this.dataExtensions)
            );
        },

        //
        // Data extension handling 
        dataExtensionAdd: function() {
            if(this.formProperties.dataExtensionBeingEdited) {
                alert("Please finish editing the current Data Extension before continuing.");
                return;
            }
            this.dataExtensions.push(this.$dataExtensionService.dataExtensionAdd());
        },
        dataExtensionEditing: function(id) {
            if (!this.formProperties.dataExtensionBeingEdited) {
                this.formProperties.dataExtensionBeingEdited = id;
            } else {
                alert("Please finish editing the current Data Extension before continuing.");
            }
        },
        dataExtensionUpdate: function(id, params, rows) {
            var i;
            for (i = 0; i < this.dataExtensions.length; i++) {
                if (this.dataExtensions[i].id == id) {
                    this.dataExtensions[i].params = params;
                    this.dataExtensions[i].rows = rows;
                    break;
                }
            }
            this.formProperties.dataExtensionBeingEdited = null;
        },
        dataExtensionDelete: function(id) {
            var i;
            if (this.formProperties.dataExtensionBeingEdited == id) {
                this.formProperties.dataExtensionBeingEdited = null;
            }
            for (i = 0; i < this.dataExtensions.length; i++) {
                if (this.dataExtensions[i].id == id) {
                    this.dataExtensions.splice(i, 1);                            
                    break;
                }
            }
        },

        //
        // Folder creation handling
        campaignFolderSelected: function(id, folderId, folderPath) {
            if (id in this.createFolders) {
                this.createFolders[id].path = folderPath;
            }
        }
    }
}
